/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {
    export function meevoZipCodeFilter(appSettings: Meevo.Components.Common.IAppSettings): angular.IFilterService {
        const filter = (input: string, country?: string) => {

            let isOtherCountry = country.toUpperCase() === "OTHER";

            let output: string = input;
            let _country = country || Meevo.Model.CountryIdEnum[appSettings.APP_COUNTRYID.replace("-", "_")].substr(3).toUpperCase();
            let _formats: string = appSettings.APP_COUNTRIES[_country]["PostalCodeFormat"].split("|")[0];   /*  TODO: Match against all formats */
            let _separator = _formats.replace(/[a-zA-Z]/g, "")

            if (!input || isOtherCountry) {
                return output;
            }

            let value = input.replace(/[\s-]/g, "")             /*  remove seperators either space or hyphen   */
            let groups = _formats.split(_separator);
            let result: any = "";
            let position: number = 0;
            _.forEach(groups, (group) => {
                let size = group.length;
                result += value.substr(position, size)
                position += size
                result += position < value.length ? _separator : ""
            })
            let results = result.split(_separator);

            result += results.length < groups.length && input[input.length - 1] === _separator ? _separator : ""

            return result;

        };

        return filter;
    }

    meevoZipCodeFilter.$inject = ["meevo.AppSettings"];

    angular.module("meevo.components.filters")
        .filter("meevoZipCode", meevoZipCodeFilter);
}
